import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function uploadCgmFile(patientId, file) {
  try {
    const token = localStorage.getItem("token");

    const formData = new FormData();
    formData.append("file", file);

    const res = await axios.post(
      `${API_BASE_URL}/api/upload-cgm-via-xl?patient_id=${patientId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return res.data;

  } catch (error) {
    console.error("CGM Upload Error:", error);
    throw error;
  }
}

// Triggers the export job and returns { s3_key, rows_exported, ... } —
// this is a JSON response, NOT the file itself. The caller (ExportCgm)
// downloads the actual .xlsx from S3 using the returned s3_key.
export async function exportCgmFile(patientOwnerId, startDate, endDate) {
  try {
    const token = localStorage.getItem("token");

    const params = { patient_owner_id: patientOwnerId };
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;

    const res = await axios.get(`${API_BASE_URL}/api/cgm/export-xlsx`, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res.data?.data || res.data;

  } catch (error) {
    console.error("CGM Export Error:", error);
    throw error;
  }
}